import type { FaireProductEntity } from "../../entity_types/product";

export const p_yzd8rzsp5z: FaireProductEntity = {
  token: "p_yzd8rzsp5z",
  type: "product",
  name: "HERBAL MEDIC",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/2050c224d19d180343086c2fcc3c6a47ab979fa74a52de68198016a03588296f.jpeg",
  galleryImageUrls: [],
  priceDollars: 17.28,
  description: "With a focus on herbal medicine and first-aid essentials, former Green Beret medic and clinical herbalist Sam Coffman presents this comprehensive home reference on medical emergency preparedness for times when professional medical care is unavailable.Herbal Medic covers first-aid essentials, such how to assess a situation and a person in need of treatment and distinguish between illness and injury, as well as how to prepare and use herbs when there is no access to conventional medical treatment. In addition, the book provides a basic introduction to herbal medicine, with detailed entries on the best herbs to use in treatment; information on disease in the body and how herbs work against it; instructions for making herbal preparations; a list of those herbs the author has found most useful in his clinical experience; and a wide array of specific herbal care protocols for a multitude of acute health issues.",
  tags: [],
  msrpDollars: 34.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:12.647Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
